import { defineComponent as _defineComponent } from 'vue'
import useIcons from '@/composables/useIcons'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExamAction',
  props: {
    actionText: {
      type: String,
      required: true,
    },
  },
  emits: ['action'],
  setup(__props, { emit }) {

  

  

  const { examIcon } = useIcons()

  const handleAction = () => {
    emit('action')
  }

return { __sfc: true,emit, examIcon, handleAction, useIcons }
}

})